var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 14.1667H3.50016C2.56674 14.1667 2.10003 14.1667 1.74351 13.9851C1.42991 13.8253 1.17494 13.5703 1.01515 13.2567C0.833496 12.9002 0.833496 12.4335 0.833496 11.5V3.50004C0.833496 2.56662 0.833496 2.09991 1.01515 1.74339C1.17494 1.42979 1.42991 1.17482 1.74351 1.01503C2.10003 0.833374 2.56674 0.833374 3.50016 0.833374H3.8335C5.70034 0.833374 6.63376 0.833374 7.3468 1.19669C7.974 1.51626 8.48394 2.0262 8.80352 2.65341C9.16683 3.36644 9.16683 4.29987 9.16683 6.16671M9.16683 14.1667V6.16671M9.16683 14.1667H14.8335C15.7669 14.1667 16.2336 14.1667 16.5901 13.9851C16.9038 13.8253 17.1587 13.5703 17.3185 13.2567C17.5002 12.9002 17.5002 12.4335 17.5002 11.5V3.50004C17.5002 2.56662 17.5002 2.09991 17.3185 1.74339C17.1587 1.42979 16.9038 1.17482 16.5901 1.01503C16.2336 0.833374 15.7669 0.833374 14.8335 0.833374H14.5002C12.6333 0.833374 11.6999 0.833374 10.9869 1.19669C10.3597 1.51626 9.84972 2.0262 9.53014 2.65341C9.16683 3.36644 9.16683 4.29987 9.16683 6.16671",
    stroke: "#0A756F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book_icon.2fe8da016eded9b84d435dd5b75a3af8.svg";
export { ForwardRef as ReactComponent };